interface propsMonths {
    index: number;
    name: string;
}

export const ListofMonsths: propsMonths[] = [
    {index: 1, name: 'Jan'},
    {index: 2, name: 'Fev'},
    {index: 3, name: 'Mar'},
    {index: 4, name: 'Abr'},
    {index: 5, name: 'Mai'},
    {index: 6, name: 'Jun'},
    {index: 7, name: 'Jul'},
    {index: 8, name: 'Ago'},
    {index: 9, name: 'Set'},
    {index: 10, name:  'Out'},
    {index: 11, name: 'Nov'},
    {index: 12, name: 'Dez'}
]